import { maxArticleUnits } from '@/config/practiceLimits'

/** @deprecated Prefer {@link maxArticleUnits} from `@/config/practiceLimits`. */
export const ARTICLE_WORD_LIMIT = maxArticleUnits

/** Fisher–Yates shuffle, returns up to `limit` items. */
export function pickRandom<T>(items: T[], limit = maxArticleUnits): T[] {
  if (items.length <= limit) return [...items]
  const copy = [...items]
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[copy[i], copy[j]] = [copy[j], copy[i]]
  }
  return copy.slice(0, limit)
}
